(() => {
  'use strict';

  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const trackPdpClick = (modal, source) => {
    document.dispatchEvent(new CustomEvent('studio-cosy:fabric-sample-opened', { detail: {
      source,
      product_handle: modal.dataset.productHandle,
      product_title: modal.dataset.productTitle
    } }));
  };

  const trackComplete = (modal) => {
    const parameters = {
      funnel: 'stofstalen',
      product_handle: modal.dataset.productHandle,
      product_title: modal.dataset.productTitle
    };

    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Lead', {
        content_category: 'stofstalen',
        content_name: modal.dataset.productTitle
      });
    }

    document.dispatchEvent(new CustomEvent('studio-cosy:fabric-sample-complete', { detail: parameters }));
  };

  const postToBrevo = (modal, values) => {
    if (!modal.dataset.brevoEndpoint) return;

    const brevoForm = document.createElement('form');
    brevoForm.method = 'POST';
    brevoForm.action = modal.dataset.brevoEndpoint;
    brevoForm.target = 'scBrevoFrame';
    brevoForm.enctype = 'multipart/form-data';
    brevoForm.hidden = true;

    const fields = {
      EMAIL: values.email,
      BANK_MODEL: modal.dataset.productTitle,
      PRODUCT_URL: modal.dataset.productUrl || window.location.href,
      STOF_NAAM: values.fabricName,
      STOF_KLEUR: values.fabricColour,
      STOF_IMG_URL: values.fabricImage,
      email_address_check: '',
      locale: 'en'
    };

    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value || '';
      brevoForm.appendChild(input);
    });

    document.body.appendChild(brevoForm);
    HTMLFormElement.prototype.submit.call(brevoForm);
    window.setTimeout(() => brevoForm.remove(), 5000);
  };

  const initialiseModal = (modal) => {
    const product = modal.closest('[data-sc-product]');
    if (!product) return;

    const dialog = modal.querySelector('.sc-sample-modal__dialog');
    const formView = modal.querySelector('[data-sc-sample-form-view]');
    const success = modal.querySelector('[data-sc-sample-success]');
    const form = modal.querySelector('[data-sc-sample-form]');
    const gift = modal.querySelector('[data-sc-sample-gift]');
    const fabrics = modal.querySelector('[data-sc-sample-fabrics]');
    const submit = modal.querySelector('[data-sc-sample-submit]');
    const error = modal.querySelector('[data-sc-sample-error]');
    let opener = null;
    let giftTimer = null;

    const revealGift = () => {
      if (gift) gift.hidden = false;
      if (giftTimer) window.clearTimeout(giftTimer);
    };

    const reset = () => {
      formView.hidden = false;
      success.hidden = true;
      if (gift) gift.hidden = true;
      if (error) error.hidden = true;
      if (submit) {
        submit.disabled = false;
        submit.textContent = 'Gratis stalenbundel aanvragen';
      }
    };

    const open = (trigger) => {
      opener = trigger;
      reset();
      modal.hidden = false;
      document.body.classList.add('sc-sample-modal-open');
      trackPdpClick(modal, trigger.dataset.source || 'unknown');
      giftTimer = window.setTimeout(revealGift, 3000);
      window.requestAnimationFrame(() => dialog.focus());
    };

    const close = () => {
      modal.hidden = true;
      document.body.classList.remove('sc-sample-modal-open');
      if (giftTimer) window.clearTimeout(giftTimer);
      if (opener && document.contains(opener)) opener.focus();
    };

    product.querySelectorAll('[data-sc-sample-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => open(trigger));
    });

    modal.querySelectorAll('[data-sc-sample-close]').forEach((button) => {
      button.addEventListener('click', close);
    });

    if (fabrics) {
      fabrics.addEventListener('mouseenter', revealGift, { once: true });
      fabrics.addEventListener('click', revealGift, { once: true });
      fabrics.addEventListener('focusin', revealGift, { once: true });
    }

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
        return;
      }

      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll(focusableSelector)].filter((element) => !element.hidden && element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        if (error) error.hidden = false;
        return;
      }

      if (error) error.hidden = true;
      submit.disabled = true;
      submit.textContent = 'Aanvraag wordt verstuurd…';

      const fabric = modal.querySelector('.sc-sample-fabric');
      const values = {
        email: form.querySelector('[name="contact[email]"]').value.trim(),
        fabricName: fabric?.dataset.fabricName || '',
        fabricColour: fabric?.dataset.firstColour || '',
        fabricImage: fabric?.dataset.firstImage || 'https://cdn.shopify.com/s/files/1/0947/7845/8459/files/701de981-9f55-4147-974a-72cc7f34639c.png?v=1764071177'
      };
      const street = form.querySelector('[name="contact[Straat]"]').value.trim();
      const houseNumber = form.querySelector('[name="contact[Huisnummer]"]').value.trim();
      const postcode = form.querySelector('[name="contact[Postcode]"]').value.trim();
      const city = form.querySelector('[name="contact[Plaats]"]').value.trim();
      const address = `${street} ${houseNumber}, ${postcode} ${city}`;
      form.querySelector('[data-sc-contact-fabric]').value = values.fabricName;
      form.querySelector('[data-sc-contact-address]').value = address;
      form.querySelector('[data-sc-contact-body]').value = `Gratis stofstalen voor ${modal.dataset.productTitle}. Stof: ${values.fabricName || 'niet opgegeven'}. Adres: ${address}. Product: ${modal.dataset.productUrl || window.location.href}`;

      try {
        postToBrevo(modal, values);
      } catch (brevoError) {
        console.warn('Brevo-stofstalenaanvraag kon niet worden verstuurd.', brevoError);
      }

      try {
        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'text/html' },
          credentials: 'same-origin',
          keepalive: true
        }).catch(() => {});
      } catch (contactError) {
        console.warn('Shopify-contactkopie kon niet worden verstuurd.', contactError);
      }

      trackComplete(modal);
      formView.hidden = true;
      success.hidden = false;
      success.focus?.();
      dialog.scrollTop = 0;
    });
  };

  const initialise = () => document.querySelectorAll('[data-sc-sample-modal]').forEach(initialiseModal);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
